import {DualscreenEvents} from './events';
export {DualscreenEvents};
